import $ from 'jquery';

const mobileNavPrimaryLinksInit = () => {
    const $mobileNav = $('.mobile-nav');
    const $subMenus = $('.c-primary-links .submenu-child-nav');
    const $parentLinks = $('a.parent-link');
    const $backLinks = $('a.back');
    const hasSubMenuClass = 'has-submenu';
    const subMenuActiveClass = 'submenu-active';
    const hasActiveSubMenuClass = 'has-active-submenu';

    // Give a class to every link with a submenu, so we can style it.
    $subMenus.each(function () {
        $(this).prev().children('button').addClass(hasSubMenuClass);
    });

    $('.c-primary-links button.has-submenu').on('click', function (e) {
        const primaryLinksActiveTab = $(e.target).parents('.c-primary-links').last().attr('id');

        e.preventDefault();
        $(this).parent().next('ul').addClass(subMenuActiveClass);
        $mobileNav.addClass(hasActiveSubMenuClass);

        document.getElementsByClassName('entry')[0].style.display = 'none';

        // move the mask 'forward'
        $(`#${primaryLinksActiveTab}`).css('transform', `translateX(-${100 * $(`.${subMenuActiveClass}`).length}%`);
    });

    $parentLinks.on('focusout', function () {
        // tabbed to the end of the line, go back to the top
        $(this).parent().parent()
            .find('.back')
            .focus();
    });

    $backLinks.on('click', function (e) {
        const primaryLinksActiveTab = $(e.target).parents('.c-primary-links').last().attr('id');

        e.preventDefault();
        $(this).parent().parent().removeClass(subMenuActiveClass);

        if ($(`.${subMenuActiveClass}`).length === 0) {
            $mobileNav.removeClass(hasActiveSubMenuClass);
            document.getElementsByClassName('entry')[0].style.display = 'flex';
        }

        // move the mask back.
        $(`#${primaryLinksActiveTab}`).css('transform', `translateX(-${100 * $(`.${subMenuActiveClass}`).length}%`);
    });
};

// doc ready
$(() => {
    mobileNavPrimaryLinksInit();
});
